module.exports = __webpack_public_path__ + "media/backgrounds/bg-mobile-e8c74fa2.svg";